
import React from 'react';
import NavBar from "../components/NavBar";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "../components/ui/alert";
import { Info } from "lucide-react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbSeparator } from "../components/ui/breadcrumb";

const LearnMore = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />
      
      <div className="container mx-auto px-4 pt-20 pb-12">
        <div className="max-w-3xl mx-auto">
          <Breadcrumb className="mb-4">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/">Home</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink href="#">Legal</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink>Contact Information</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
          
          <Card className="shadow-sm border border-gray-200">
            <CardHeader className="pb-2 border-b">
              <div className="flex items-center gap-3 mb-2">
                <Info className="h-6 w-6 text-gray-700" />
                <CardTitle className="text-2xl font-bold text-gray-800">Contact Information on WANTTD</CardTitle>
              </div>
            </CardHeader>
            
            <CardContent className="pt-6">
              <div className="space-y-6">
                <p className="text-gray-600">
                  WANTTD users may upload their contacts to help find friends and connections on our platform. This helps create 
                  a more personalized experience and allows users to connect with people they know.
                </p>
                
                <Alert>
                  <AlertTitle>Your Options</AlertTitle>
                  <AlertDescription className="text-gray-600">
                    If you believe someone has uploaded your contact information and you'd prefer not to be found this way, 
                    you have several options:
                  </AlertDescription>
                </Alert>
                
                <div className="bg-white rounded-lg border border-gray-200 divide-y">
                  <div className="p-4">
                    <h3 className="font-medium text-gray-900 mb-2">Create an account</h3>
                    <p className="text-sm text-gray-600">
                      By signing up, you'll have full control over your privacy settings 
                      and who can find you on the platform.
                    </p>
                  </div>
                  
                  <div className="p-4">
                    <h3 className="font-medium text-gray-900 mb-2">Contact our support team</h3>
                    <p className="text-sm text-gray-600">
                      If you don't want to create an account but want your information removed, 
                      please contact us at <span className="text-blue-600">privacy@wanttd.com</span>.
                    </p>
                  </div>
                  
                  <div className="p-4">
                    <h3 className="font-medium text-gray-900 mb-2">Adjust your settings</h3>
                    <p className="text-sm text-gray-600">
                      If you already have an account, you can modify who can find you through 
                      uploaded contacts in your privacy settings.
                    </p>
                  </div>
                </div>
                
                <p className="text-gray-600">
                  We're committed to protecting your privacy and giving you control over your information. For more details, 
                  please see our full Privacy Policy.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default LearnMore;
